import { render, staticRenderFns } from "./BaseCsvImport.vue?vue&type=template&id=521495ee"
import script from "./BaseCsvImport.vue?vue&type=script&lang=js"
export * from "./BaseCsvImport.vue?vue&type=script&lang=js"
import style0 from "./BaseCsvImport.vue?vue&type=style&index=0&id=521495ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports